import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import axios from '../../api/axios';
import { RESET_PASS } from '../../store/Utility/Resource';
import { useSpinner } from '../../context/SpinnerContext';
import Modal from 'react-bootstrap/Modal';
import { FormGroup, Label } from 'reactstrap';


const PasswordReset = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');
    const email = queryParams.get('email');
    const [password, setPassword] = useState('');
    const [passwordConfirm, setPasswordConfirm] = useState('');
    const [modal, showModal] = useState({ show: false, message: null, isSuccess: null });
    const [validationError, setValidationError] = useState({});
    const { showLoader, hideLoader } = useSpinner();
    const [showPassword, setShowPassword] = useState(false);
    const togglePassword = () => setShowPassword(!showPassword);

    const handleClose = () => showModal({ show: false });

    const handleGoToLogin = () => {
        showModal({ show: false, message: null, isSuccess: null });
        navigate('/login');
    }

    const rules = [
        {
            id: 1,
            label: 'At least 8 characters',
            test: (pw) => pw?.length >= 8,
        },
        {
            id: 2,
            label: 'At least one uppercase letter',
            test: (pw) => /[A-Z]/.test(pw),
        },
        {
            id: 3,
            label: 'At least one lowercase letter',
            test: (pw) => /[a-z]/.test(pw),
        },
        {
            id: 4,
            label: 'At least one digit',
            test: (pw) => /[0-9]/.test(pw),
        },
        {
            id: 5,
            label: 'At least one special character ( !@#+$%^&* )',
            test: (pw) => /[!@#+$%^&*]/.test(pw),
        },
    ];

    const validatePassword = (password) => {
        const errors = [];

        const allValid = rules.every(rule => rule.test(password));
        if (!allValid) {
            errors.push("Your password doesn’t meet all the requirements.");
        }
        if (password !== passwordConfirm) {
            errors.push("Password and confirmation password do not match.");
        }

        return errors;
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        let errors = validatePassword(password);

        if (Object.keys(errors).length != 0) {
            setValidationError(errors);
            return;
        }

        showLoader();
        try {
            const response = await axios.post(RESET_PASS,
                JSON.stringify({ "email": email, "password": password, "confirmedPassword": passwordConfirm, token: token }),
                {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    withCredentials: true
                });
            var res = response?.data;
            if (res.data == false) {
                showModal({ show: true, message: "Your password reset could not be completed because the link has already been used!", isSuccess: false });
            } else {
                showModal({ show: true, message: "Your password has been successfully created. You can log in to your account using the button below.", isSuccess: true });
            }
            setValidationError({});
            hideLoader();
        } catch (err) {
            showModal({ show: true, message: "An error occured while saving!", isSuccess: false });
            hideLoader();
            if (!err?.response) {
                // setErrMsg('No server response');
            } else if (err.response?.status === 400) {
                // setErrMsg('Missing username or password');
            } else if (err.response?.status === 401) {
                // setErrMsg('UnAuthorized')
            } else {
                // setErrMsg('Login Failed');
            }
            // err.current.focus();
        }
    }

    return (
        <div className="page-content">
            <div>
                <div>
                    <div>
                        {<Modal show={modal.show} onHide={handleClose} centered>
                            <Modal.Header closeButton>
                                <Modal.Title>{modal.isSuccess ? 'Result' : 'Error'}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>{modal.message}</Modal.Body>
                            <Modal.Footer>
                                {modal.isSuccess && <button className="btn btn-dark" onClick={handleGoToLogin}>Login</button>}
                                {!modal.isSuccess && <button className="btn btn-dark" onClick={handleClose}>Close</button>}
                            </Modal.Footer>
                        </Modal>}
                        <section>
                            <div className="container">
                                <div className="row align-items-center">
                                    <div className="col-lg-7 col-12">
                                        <img className="img-fluid" src={require("../../assets/images/login.png")} alt="" />
                                    </div>
                                    <div className="col-lg-5 col-12">
                                        <div>
                                            <h2 className="mb-3">Reset Password</h2>
                                            <form onSubmit={handleSubmit}>
                                                <div className="messages"></div>
                                                <FormGroup floating>
                                                    <input
                                                        id="password"
                                                        type={showPassword ? "text" : "password"}
                                                        name="password"
                                                        className="form-control"
                                                        placeholder="New Password"
                                                        onChange={(e) => setPassword(e.target.value)}
                                                        value={password}
                                                        required="required"
                                                        data-error="password is required." /><i
                                                        className={`la ${showPassword ? "la-eye-slash" : "la-eye"} position-absolute`}
                                                        style={{
                                                          top: '50%',
                                                          right: '10px',
                                                          transform: 'translateY(-50%)',
                                                          cursor: 'pointer',
                                                          color: '#6c757d'
                                                        }}
                                                        onClick={togglePassword}
                                                      ></i>
                                                    <Label for="firstName" style={{ fontSize: '0.8rem' }}>New Password</Label>
                                                </FormGroup>

                                                <FormGroup floating>
                                                    <input
                                                        id="passwordConfirm"
                                                        type="password"
                                                        name="passwordConfirm"
                                                        className="form-control"
                                                        placeholder="Confirm New Password"
                                                        onChange={(e) => setPasswordConfirm(e.target.value)}
                                                        value={passwordConfirm}
                                                        required="required"
                                                        data-error="password confirm is required." />
                                                    <Label for="firstName" style={{ fontSize: '0.8rem' }}>Confirm New Password</Label>
                                                </FormGroup>
                                                <div className='form-group'>
                                                    <div className='row'>
                                                        <ul className="list-unstyled">
                                                            {rules.map((rule) => {
                                                                const isValid = rule.test(password);
                                                                return (
                                                                    <li key={rule.id} className={`d-flex align-items-center mb-2`}>
                                                                        <i
                                                                            className={`la ${isValid ? 'la-check-circle text-success' : 'la-times-circle text-danger'
                                                                                } me-2`}
                                                                            style={{ fontSize: '1rem' }}
                                                                        ></i>
                                                                        <span className={isValid ? 'text-success' : 'text-danger'}>
                                                                            {rule.label}
                                                                        </span>
                                                                    </li>
                                                                );
                                                            })}
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className='form-group'>
                                                    <div style={{ color: "red", fontSize: "0.9rem" }}>
                                                        {Object.keys(validationError).length > 0 ? Object.values(validationError).map(item => <div className="row"><span>* {item}</span></div>) : null}
                                                    </div>
                                                </div>


                                                <button className="btn btn-primary">Reset Password</button>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PasswordReset;